// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"96e41bb6","396":"acb6789b","455":"6d206924","977":"e5183a2d"}[chunkId] + ".chunk.js";
};